module.exports = __webpack_public_path__ + "img/Vector (1).f92f7af2.svg";